import { BehaviorSubject } from "rxjs";
import * as i0 from "@angular/core";
import * as i1 from "./kiosk.service";
var ScreenSaverService = /** @class */ (function () {
    function ScreenSaverService(kioskService) {
        this.kioskService = kioskService;
        this.showing = new BehaviorSubject(false);
        this.animation = new BehaviorSubject('');
        this.logoutCmd = new BehaviorSubject(0);
        this.showScreenSaverAfterMin = 5;
        //showScreenSaverAfterMin = 0.3;
        this.isApp = this.kioskService.isKiosk();
    }
    ScreenSaverService.prototype.logout = function () {
        if (this.isApp) {
            this.logoutCmd.next(Math.round(+new Date() / 1000) + Math.random());
        }
    };
    ScreenSaverService.prototype.hideScreenSaver = function () {
        if (this.isApp) {
            this.setSaveScreenTimer();
            this.hide();
        }
    };
    ScreenSaverService.prototype.setSaveScreenTimer = function () {
        var _this = this;
        if (this.isApp) {
            this.clearSaveScreenTimer();
            this.showScreenSaverTimer = setTimeout(function () {
                console.log("setSaveScreenTimer");
                _this.show();
                document.body.click();
                _this.logout();
            }, this.showScreenSaverAfterMin * 60 * 1000);
        }
    };
    ScreenSaverService.prototype.clearSaveScreenTimer = function () {
        clearTimeout(this.showScreenSaverTimer);
    };
    ScreenSaverService.prototype.show = function () {
        this.showing.next(true);
    };
    ScreenSaverService.prototype.hide = function () {
        this.showing.next(false);
    };
    ScreenSaverService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ScreenSaverService_Factory() { return new ScreenSaverService(i0.ɵɵinject(i1.KioskService)); }, token: ScreenSaverService, providedIn: "root" });
    return ScreenSaverService;
}());
export { ScreenSaverService };
